<template>
  <div :class="['select-wrapper', {'select-wrapper-br': isBr}]" @click="selectClick">
    <cube-select
      v-model="formItem.value"
      :title="formItem.title"
      :options="itemOptions"
      :placeholder="formItem.placeholder || formItem.title"
      :disabled="relyKeyItem && !otherKeyOption.length"
      :confirmTxt="$t('确认')"
      :cancelTxt="$t('取消')"
      @change="changeSelect"
    >
    </cube-select>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { emitFormUpdate, getLocation } from "../../tools/utils";
import { post } from "../../tools/request";
import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../../tools/constant";

// 手机号基本格式
const REG_PHONE_NUM = /^\d+$/;

export default {
  props: ["formItem", "idx", "relyKeyItem"],
  data() {
    return {
      phoneNum: "",
      phoneNumValidate: false,
    };
  },
  mounted() {
    // console.log(this.relyKeyItem)
  },
  watch: {
    itemOptions: {
      handler(newV) {
        if (newV) {
          let defaultOption = newV.find(item => item.default)
          if (defaultOption) {
            if (this.formItem.key === 'product') {
              if (!this._product_change) {
                this.formItem.value = defaultOption.value;
                this.setState({
                  _product: this.formItem.value,
                  _product_name: defaultOption.text,
                });
              } else {
                this.formItem.value = this._product;
              }
              // getLocation(this.getLocateCity);
            } else {
              this.formItem.value = defaultOption.value
            }
            emitFormUpdate(this, this.idx);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    _product: {
      handler(newV, oldV) {
        if (newV && this.formItem.key === 'product') {
          // 每次切换城市先清空城市
          this.setState({
            _area: {
              text: '',
              value: '',
            },
          });
          getLocation(this.getLocateCity);
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapState(["_ticket", "_login_btn_text", "_phone_focus_global", "_product", "_area", "_product_change"]),
    isWA() {
      return true;
    },
    isBr() {
      return this.formItem.style === "h5_br" || this.formItem.style === "whatsapp_br";
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    otherKeyOption() {
      if (!this.relyKeyItem) return null
      let otherKeyValue = (this.relyKeyItem || []).value
      if (otherKeyValue && otherKeyValue != 0) {
        return this.formItem.option_list[otherKeyValue] || []
      } else {
        return []
      }
    },
    itemOptions() {
      let other_key_value = this.formItem.other_key_value;
      if (this.formItem.key === 'identity') {
        other_key_value = other_key_value || 2;
      }
      return this.relyKeyItem ? this.otherKeyOption :
              other_key_value ? this.formItem.option_list[other_key_value] : this.formItem.options;
    }
    // otherKeyOptionDefault() {
    //   console.log(this.otherKeyOption.find(item => item.default))
    //   return this.otherKeyOption.find(item => item.default)
    // }
  },
  methods: {
    ...mapMutations(["setState"]),
    selectClick() {
      Omega.trackEvent("ibt_gd_whatsapp_select_box_ck", "", {
        type: this.formItem.key
      });
    },
    changeSelect(value, index, text) {
      this.formItem.value = value
      if (this.formItem.key === 'product') {
        // getLocation(this.getLocateCity);
          this.setState({
            _product: this.formItem.value,
            _product_change: true,
            _product_name: text,
          });
      }
      emitFormUpdate(this, this.idx);
    },
    getLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("lng", lng);
      up.set("lat", lat);
      if (this._product) {
        up.set("product", this._product);
      }

      post(process.env.LANDING_PAGE_GET_LOCATE_CITY, up)
        .then((data) => {
          this.setState({
            _area: {
              text: data.text,
              value: data.value,
            },
            _open_type: data.open_type,
          });
          this.$emit("refresh", 'city');
          Omega.trackEvent(
            "ibt_onboarding_landingpagecity_sw",
            "",
            this.omegaItem
          );
        })
        .catch((err) => {
          this.setState({
            _area: {
              text: '',
              value: '',
            },
          });
          // console.log(err);
        });
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.select-wrapper {
  // padding: 0.24rem;
  margin: 0 0.4rem 0.24rem 0.4rem;
  .cube-select {
    height: .96rem;
    padding: 0.24rem .56rem .24rem .24rem;
    border-radius: 0.08rem;
    border: 0.02rem solid #dddddd;
    font-size: .32rem;
    font-weight: 700;
    &::after,
    .cube-select-icon {
      display: none;
    }
    ::v-deep .cube-select-placeholder,
    ::v-deep .cube-select-text {
      font-size: .32rem;
      font-weight: 700;
    }
    ::v-deep .cube-select-icon {
      width: .32rem;
      height: .32rem;
      right: .24rem;
      border: none;
      background-size: 0.32rem;
      background-image: url("../../images/icon_arrow_down.png");
    }
  }
  &.select-wrapper-br {
    margin: 0 0 0.32rem 0;
    .cube-select {
      height: auto;
      padding: 0.34rem 0.4rem;
      background: rgba(145, 160, 180, 0.15);
      border-radius: 0.12rem;
      border: none;
    }
  }
}
</style>


